export default __webpack_public_path__ + "static/media/ap-multistep.11854cd3.jpg";